import { useSuspenseQuery } from '@tanstack/react-query';

import api from 'src/axios';
import type { ConfigurationCriteriaEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaEnum';
import { getSessionCriteriaQueryKey } from 'src/keys';

export type OpenSessionCriterion = {
  name: `${ConfigurationCriteriaEnum}`;
  values?: Record<string, string | number>;
  products: string[];
  apply: boolean;
};

export type OpenSessionCriteria = OpenSessionCriterion[];

export function useSessionCriteriaQuery(sessionId: string) {
  return useSuspenseQuery<OpenSessionCriteria>({
    queryKey: getSessionCriteriaQueryKey(sessionId),
    queryFn: async () => {
      const { data } = await api.get<OpenSessionCriteria>(
        `/sales-forecasting-sessions/${sessionId}/criteria`,
      );

      return data;
    },
  });
}
